module.exports = __webpack_public_path__ + "209b9e6cbe1a545da13e0210de6b11e6.jpg";